import React from "react";

//mui
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import useTranslation from "../hooks/useTranslation";

const LocationInput = ({ location, setLocation }) => {
  const { t } = useTranslation();
  return (
    <FormControl>
      <FormLabel id="demo-radio-buttons-group-label" className="pb-[30px]">
        <span className="text-[#9B9B9B] text-base tracking-wider capitalize ">
          {t("Localisation")}
        </span>
      </FormLabel>
      <FormControl variant="contain">
        <FormControl variant="outlined">
          <OutlinedInput
            value={location}
            onChange={(event) => setLocation(event.target.value)}
            placeholder={t("Adresse, i.e Bab E-zouar")}
            sx={{
              fieldset: {
                border: "none",
                outline: "none",
              },
              borderRadius: "15px",
              background: "#F7EFFA",
              fontSize: "14px",
              fontFamily: "Myriad Pro",
              marginTop:"1rem"
            }}
            startAdornment={
              <InputAdornment position="start">
                <img
                  src="/svg/location.svg"
                  alt="location"
                  className="cursor-pointer"
                />
              </InputAdornment>
            }
            aria-describedby="outlined-weight-helper-text"
            inputProps={{
              "aria-label": "weight",
            }}
          />
        </FormControl>
      </FormControl>
    </FormControl>
  );
};

export default LocationInput;
